/**
 * Hastanın onam imzası sayfasının genel yolu: `${origin}${PUBLIC_CONSENT_PATH}/${belirteç}`.
 *
 * **Tek kaynak (H20, ödeme yolunun aynısı).** Bağlantıyı SUNUCU kurar (`consents.service.ts`
 * `createConsentLink`), adresi WEB çözer (`app/routes.ts` `parseConsentPath`). İki taraf arasındaki
 * tek köprü bu pakettir; dize iki yerde elle yazılsaydı biri değişince hastanın eline giden
 * bağlantı sessizce 404'e düşerdi — 2026-09-23'te tam olarak bu oldu: sunucu `/onam/<belirteç>`
 * üretiyordu, web'de o yolu karşılayan sayfa hiç yoktu.
 *
 * Bu dosyaya zod (ya da zod'a dokunan bir modül) import ETME: rota tablosu bu sabiti okurken
 * şemaları da giriş grafiğine çekerdi (`payments-path.ts`te ölçülmüş gerekçe).
 */
export const PUBLIC_CONSENT_PATH = '/onam';
//# sourceMappingURL=consents-path.js.map